import script from "./AppInvitation.vue?vue&type=script&setup=true&lang=js"
export * from "./AppInvitation.vue?vue&type=script&setup=true&lang=js"

import "./AppInvitation.vue?vue&type=style&index=0&id=287faa2d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-287faa2d"]])

export default __exports__